import Footer from 'ui/snippets/footer/Footer';

import Container from './Container';
import Content from './Content';
import MainArea from './MainArea';
import MainColumn from './MainColumn';
import NavBar from './NavBar';
import Root from './Root';
import SideBar from './SideBar';

export {
  Root,
  Container,
  Content,
  MainArea,
  SideBar,
  NavBar,
  MainColumn,
  Footer,
};

// Root
//  Container
//    MainArea
//       SideBar
//       MainColumn
//          Content
//    Footer
